import { AVATAR_COLORS } from '@/constants';

/**
 * Generate a consistent color based on a string (e.g., username)
 * Same input will always produce the same color
 * @param {string} name - The name to generate a color for
 * @returns {string} - A hex color code
 */
export const getAvatarColor = (name) => {
  if (!name) return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

/**
 * Get initials from a name (e.g., "John Doe" -> "JD")
 * @param {string} name - The full name
 * @returns {string} - The initials (1-2 characters)
 */
export const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};
